import { ChangeLogEntryData } from "./ChangeLogEntryData";

export class ToolVersionData {
  public name: string;
  public id: string;
  public toolId: string;
  public minSupportedVersion: string;
  public maxSupportedVersion: string;
  public publishedUTC: Date;
  public changeLog: Array<ChangeLogEntryData>;
  public originalChangeLog: Array<ChangeLogEntryData>;

  constructor(
    pName: string,
    pMinSupportedVersion: string,
    pMaxSupportedVersion: string,
    pPublshedUTC: Date,
    pChangeLog: Array<ChangeLogEntryData>,
    pId: string,
    pOwnerId: string,
    pOriginalChangeLog: Array<ChangeLogEntryData>
  ) {
    this.name = pName;
    this.maxSupportedVersion = pMaxSupportedVersion;
    this.minSupportedVersion = pMinSupportedVersion;
    this.publishedUTC = pPublshedUTC;
    this.changeLog = pChangeLog;
    this.id = pId;
    this.toolId = pOwnerId;
    this.originalChangeLog = pOriginalChangeLog;
  }
}
